/**
 * Author: Romain Hapi, Prenim Ltd
 * Version: 1.0
 * Date: 2026-10-22
 * Project: Prenim Digital
 * Copyright: Prenim Ltd
 */
/**
 * Grille des logiciels Prenim, partagee par l'accueil et les realisations.
 *
 * Chaque carte mene a la page detaillee du produit. `limit` permet a l'accueil
 * de n'en montrer qu'une partie.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PRODUCTS, PRODUCT_UI, tx } from "../lib/products";

const ProductCards = ({ lang, limit }) => {
  const items = limit ? PRODUCTS.slice(0, limit) : PRODUCTS;
  const l = lang === "fr" ? "fr" : "en";

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((p) => (
        <Link
          key={p.slug}
          to={`/products/${p.slug}`}
          data-testid={`product-card-${p.slug}`}
          className="group flex flex-col bg-white rounded-2xl border border-slate-200 overflow-hidden card-lift"
        >
          <div className="aspect-[4/3] overflow-hidden bg-slate-100 flex items-center justify-center">
            <img
              src={p.cover[l]}
              alt={p.name}
              className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <div className="p-7 flex flex-col flex-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-semibold">
                {tx(p.category, lang)}
              </span>
            </div>
            <h3 className="text-xl font-bold text-slate-950 mb-2">{p.name}</h3>
            <p className="text-sm font-medium text-slate-700 mb-3">{tx(p.tagline, lang)}</p>
            <p className="text-sm text-slate-600 leading-relaxed flex-1">{tx(p.summary, lang)}</p>
            <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-blue-600 group-hover:gap-3 transition-all">
                {tx(PRODUCT_UI.discover, lang)}
                <ArrowRight className="h-4 w-4 rtl-flip" />
              </span>
              <span className="rounded-full bg-blue-600 text-white text-xs font-semibold px-3.5 py-2">
                {tx(PRODUCT_UI.ctaDemo, lang)}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default ProductCards;
